import React, { useContext, useEffect, useState, useMemo } from "react";
import "../MmcqCards/mmcqCard.css";
import TestOption from "../../Option";
import OTQuestionCard from "../Question";
import { GlobalContext } from "../../../../../context/GlobalState";
import Attachment from "../../../../shared/Attachment";
import Divider from "../../../../shared/Divider";
import { getSignedURL, uploadFileToS3 } from "../../../../../utils/file";
import { input } from "../../helper";

const parseData = (id) => JSON.parse(localStorage.getItem(id));
const isChecked = (id, optionId) => {
  const data = localStorage.getItem(id) && parseData(id);
  if (!data) return false;
  return data?.optionId === optionId;
};

export default function AssertionReasoningCard({
  color = "",
  data,
  number,
  correctAnswer,
  setCorrectAnswer,
  onlineTestId,
}) {
  const question = data;

  const { userDetails } = useContext(GlobalContext);
  const [status, setStatus] = useState("");

  function setAnswer(updatedAnswer) {
    const answer = {
      ...correctAnswer,
      ...updatedAnswer,
    };
    localStorage.setItem(id, JSON.stringify(answer));
    setCorrectAnswer(answer);
  }

  async function onFileUpload(e) {
    const file = e.target.files[0];
    if (status === "uploading" || !file) return;
    setStatus("uploading");

    try {
      const { signedURL } = await getSignedURL({
        id: `students/${userDetails?.userId}/questions/${question._id}`,
        fileName: file.name,
        fileType: file.type,
      });
      await uploadFileToS3(file, signedURL);
      setAnswer({
        file: {
          name: file.name,
          link: signedURL.split("?")[0],
        },
      });
      setStatus("");
    } catch (err) {
      setStatus("error");
    }
  }

  const handleChange = (e) => {
    setAnswer({ answer: e.target.value });
  };

  const id = useMemo(() => {
    return onlineTestId + "," + question._id;
  }, [onlineTestId, question]);

  const handleClick = (e) => {
    if (correctAnswer) {
      correctAnswer.optionId = isChecked(id, e.target.value)
        ? null
        : e.target.value;
      setCorrectAnswer({ ...correctAnswer });
      localStorage.setItem(id, JSON.stringify(correctAnswer));
    } else {
      const answer = { optionId: e.target.value };
      setCorrectAnswer(answer);
      localStorage.setItem(id, JSON.stringify(answer));
    }
  };

  useEffect(() => {
    if (window.MathJax) {
      return window.MathJax.typesetPromise();
    }
  }, [question.question]);

  return (
    <OTQuestionCard
      number={number}
      color={color}
      question={{
        label: "Assertion and Reasoning",
        description: question.description,
        image: question.images?.questionImg,
        assertImg: question.images?.assertImg,
        reasonImg: question.images?.reasonImg,
        title: question?.question || "",
        signature: {
          role: question.onModel,
          teacherName: question?.creatorId?.name,
          schoolName: question?.schoolId?.name,
        },
      }}
    >
      <div>
        <div className="options options-column">
          <TestOption
            key={question?.options[0]?.optionId}
            image={question.images?.op1}
            option={question.options[0]}
            isChecked={isChecked(id, question?.options[0]?.optionId)}
            select={handleClick}
            type="radio"
          />
          <TestOption
            key={question?.options[1]?.optionId}
            image={question.images?.op2}
            option={question.options[1]}
            isChecked={isChecked(id, question?.options[1]?.optionId)}
            select={handleClick}
            type="radio"
          />
          <TestOption
            key={question?.options[2]?.optionId}
            image={question.images?.op3}
            option={question.options[2]}
            isChecked={isChecked(id, question?.options[2]?.optionId)}
            select={handleClick}
            type="radio"
          />
          <TestOption
            key={question?.options[3]?.optionId}
            image={question.images?.op4}
            option={question.options[3]}
            isChecked={isChecked(id, question?.options[3]?.optionId)}
            select={handleClick}
            type="radio"
          />
        </div>
        <br />
        <div style={{ width: "100%" }}>
          <h3>Explain</h3>
          <div className="question-input-field">
            <Attachment
              name={correctAnswer?.file?.name}
              link={correctAnswer?.file?.link}
              status={status}
              upload={onFileUpload}
            />
            <Divider />
            <textarea
              className="textarea"
              placeholder="Type your answer here..."
              style={input(color)}
              value={correctAnswer?.answer || ""}
              id="one_word_input"
              onChange={handleChange}
              readOnly={["uploading", "removing"].includes(status)}
            />
          </div>
        </div>
      </div>
    </OTQuestionCard>
  );
}
